import CellGroup from "@/component/Cell/CellGroup";
import ActionSheet, { ActionSheetProps } from "../ActionSheet";
import IcLink from "@/assets/share/ic_copy_link.svg?react";
import IcShareMember from "@/assets/share/ic_share_member.svg?react";
import IcAddressBook from "@/assets/share/ic_address_book.svg?react";
import IcSetting from "@/assets/share/ic_setting.svg?react";
import Cell from "@/component/Cell/Cell";
import { IShareSettingAttr, MeetingSharesItem } from "@/types/share";
import Avatar from "@/component/Avatar";
import { getSpeakerAvatarInfo } from "@/utils/newAvatar";
import { avatarBgs } from "@/constants/record";
import { PermissionChoose, PermissionStatusMap, RoleType } from "@/constants/share";
import { IShareLinkInfo } from "@/types/summary";
import LinkValidityRefreshBtn from "./LinkValidityRefreshBtn";
import { IPartialShareSettingAttr } from "@/types/share";

function AvatarGroup(props: { users: MeetingSharesItem[] }) {
  const { users } = props;
  const leftCount = users.length - 3;

  return (
    <div className="h-8 bg-mx-white rd-3 flex items-center justify-end">
      {users.slice(0, 3).map((user, index) => {
        const sharerAvatarInfo = getSpeakerAvatarInfo(user.avatar);
        return (
          <Avatar
            key={user.identityId}
            className="w-8 h-8 text-3 font-600 ml--1 b-1 b-solid b-white rounded-ful"
            userInfo={{
              userId: user.identityId,
              displayName: user.name,
              avatarUrl: sharerAvatarInfo.avatarUrl,
              avatarIndex: sharerAvatarInfo.avatarIndex || index % avatarBgs.length,
            }}
          />
        )
      }
      )}
      {leftCount > 0 && <div className="w-8 h-8 b-1 b-solid b-white rounded-full text-align-center lh-8 text-size-3 text-#30343C bg-#ECEEF3">{leftCount}人</div>}
    </div>
  );
}



export default function ShareSheet(
  props: Pick<ActionSheetProps, "onClose"> & {
    visible: boolean;
    addressVisible: boolean;
    shareInfo: IShareLinkInfo | null;
    mySharePermission: string;
    shareList: MeetingSharesItem[];
    shareSetting: IShareSettingAttr;  
    onCopyLink?: () => void;
    onShowShare?: () => void;
    onShowAddress?: () => void;
    onShowLinkShare?: () => void;
    onShowSecurity?: () => void;
    onShareSettingChange: (newParams: IPartialShareSettingAttr) => void;
    disabled: boolean;
  }
) {
  const { visible, addressVisible, shareInfo, shareList, shareSetting, mySharePermission, onCopyLink, onClose, onShowShare, onShowAddress, onShowLinkShare, onShowSecurity, onShareSettingChange, disabled } = props;

  return (
    <ActionSheet
      title="分享"
      visible={visible}
      onClose={onClose}
      className="h-133 bg-#F4F6F9!"
    >
      <div className="p-6">
        <div className="flex">
          <div className="flex flex-col items-center justify-center"
            onClick={() => { onCopyLink?.(); }}>
            <div className="bg-mx-white rd-3 w-12.5 h-12.5 flex items-center justify-center">
              <IcLink className="w-8.5 h-8.5" />
            </div>
            <div className="m-t-2.5 font-size-2.5 line-height-2.5 color-#1F2533 ">
              复制链接
            </div>
          </div>
        </div>
        <CellGroup className="m-t-4 w-full">
          <Cell
            icon={<IcShareMember className="w-5 h-5" />}
            title="共享人"
            value={<AvatarGroup users={shareList} />}
            arrow={false}
            onClick={() => {
              onShowShare?.();
            }}
          />
          {addressVisible && <Cell
            icon={<IcAddressBook className="w-5 h-5" />}
            title="从通讯录添加"
            onClick={() => {
              onShowAddress?.();
            }} />
          }
        </CellGroup>
        {<CellGroup className="m-t-4 w-full">
          <Cell
            icon={<IcLink className="w-5 h-5" />}
            title={
              <div className="flex flex-col">
                <div>{PermissionStatusMap[shareSetting?.shareScope as PermissionChoose]}</div>
                <LinkValidityRefreshBtn
                  shareInfo={shareInfo}
                  disabled={disabled}
                  onShareSettingChange={onShareSettingChange}
                />
              </div>
            }
            disabled={disabled}
            onClick={() => {
              onShowLinkShare?.();
            }}
          />
          {(mySharePermission === RoleType.Creator || mySharePermission == RoleType.Manager) &&
            <Cell
              icon={<IcSetting className="w-5 h-5" />}
              title="安全设置"
              onClick={() => {
                onShowSecurity?.();
              }} />
          }
        </CellGroup>
        }
      </div>
    </ActionSheet>
  );
}

